import { FunctionComponent } from 'react';
import { useBlock } from '../hooks/useBlock';
import { Blocks } from '../constants/blocks';
import parse from 'html-react-parser';

export const Block: FunctionComponent<{ k: Blocks }> = ({ k }) => {
  const block = useBlock(k);
  return <>{parse(block)}</>;
};
